<template>
  <div >
    <div v-if="!isTripartite && !isPrivate">
      <div class="footer f1" >
        <div class="top" >
          <div class="left">
            <p>{{$t('protalTitle22')}}</p>
            <p>
              <span>
                <router-link to="/open/help">{{$t('protalTitle23')}}</router-link>
              </span>
              <span>
                <a  @click="jumpFeedback">{{$t('protalTitle24')}}</a>
              <!-- <router-link :to="$t('abkLink')+'/open/feedback'">{{$t('protalTitle24')}}</router-link> -->
              </span>
            </p>
            <p>{{$t('protalTitle25-aibiaoke')}}</p>
            <p style="position: absolute;top: 135px;width: 350px;">{{$t('protalTitle26')}}</p>
            <p style="position: absolute;top: 175px;width: 350px;">{{$t('protalTitle26_')}}</p>
          </div>
          <div class="right">
            <div class="item">
              <p class="title">{{$t('protalTitle27')}}</p>
              <p class="list">
                <a @click="jumpAbout(3)">{{$t('protalTitle35')}}</a>
              <!-- <router-link to="/open/agreement">服务条款</router-link> -->
              </p>
            </div>
            <div class="item">
              <p class="title">{{$t('protalTitle29')}}</p>
              <p class="list">
                <router-link to="/open/help">{{$t('protalTitle30')}}</router-link>
              </p>
            </div>
            <div class="item">
              <p class="title">{{$t('protalTitle31')}}</p>
              <p class="list">
                <a  @click="jumpAbout(1)">{{$t('protalTitle31')}}</a>
              </p>
            </div>
            <div class="item" style="padding-left: 80px;">
              <p class="title">{{$t('protalTitle36')}}</p>
              <p class="img">

              </p>
              <p class="list">{{$t('protalTitle37')}}</p>
            </div>
          </div>
        </div>

        <div class="bottom">
          <div class="content">
            <span>{{$t('protalTitle33')}}</span>
            <a target='_blank' style='color: #333' href='https://beian.miit.gov.cn' >{{$t('protalTitle38')}}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  routePathData,
  abkLink
} from 'assets/scripts/common';
export default {

  data () {
    return {
      routePathData: routePathData,
      menuActiveName: '',
      changePasswordVisual: false,
      password: {
        changePassword: ''
      },
      keyWord: '',
      navPath: {
        default: '/open/default',
        task: '/open/task',
        union: '/open/union',
        work: '/open/work',
        help: '/open/help'
      },
      curPath: ''

    };
  },
  props: ['isTripartite', 'isPrivate'],
  watch: {
    $route (val) {
      this.curPath = val.path;
    }
  },
  methods: {
    abkLink: function () {
      return abkLink();
    },
    navLink: function (link) {
      window.open(link);
    },
    // flag 记录跳转到的页面侧边栏显示对应选择项
    jumpAbout: function (flag) {
      this.$router.push('/about/aboutus?flag=' + flag)
    },
    jumpFeedback: function () {
      this.$router.push('/user/feedback')
    }
  },
  created () {
    this.curPath = this.$route.path;
  }
};
</script>

<style rel="stylesheet/less" lang="less" scoped>
  @import "../../assets/theme/themeBlue.less";

  .footer {
    width: 100%;
    height: 300px;
    background: #fff;
    padding: 38px 0;
    margin-top:20px;
    a{
    color:#999999;
    }
    a:hover{
    color:#14CB7E;
    }

    .top {
      overflow: hidden;
      width: 1200px;
      height: 250px;
      margin: 0 auto;

      .left {
        width: 300px;
        width: 250px;
        float: left;
        position: relative;

        p:nth-child(1) {
          font-size: 16px;
          font-weight: 400;
          color: rgba(52, 57, 81, 1);
        }

        p {
          font-size: 14px;
          color: #999999;
        }

        p:nth-child(2) {
          margin-top: 17px;
          span {
            font-size: 14px;
            color: rgba(41, 204, 139, 1);
            margin-right: 35px;
            a{
              color: #14CB6B;
            }
          }
        }

        p:nth-child(3) {
          margin-top: 30px;
          margin-bottom: 10px;
        }
      }

      .right {
        width: 950px;
        float: left;
        padding: 0 75px;
        overflow: hidden;

        .item {
          width: 200px;
          float: left;

          .title {
            font-size: 16px;
            color: rgba(52, 57, 81, 1);
            margin-bottom: 18px;
          }

          .list {
            font-size: 14px;
            color: #999999;
          }

          .img {
            width: 102px;
            height: 102px;
            margin-top: -5px;
            margin-bottom: 10px;
            background: url(../../assets/images/default/gongzhonghao.png)  no-repeat center center;
            background-size:100% 100%;
          }
        }
      }
    }

    .bottom {
      text-align: center;
      border-top: 1px solid #E6E6E6;

      .content {
        width: 1200px;
        margin: 0 auto;
        line-height: 50px;
        font-size: 14px;
        color: #333;
      }
    }
  }

  .robotPic {
    position: fixed;
    bottom: 40px;
    right: 40px;
    width: 50px;
    height: 50px;
    border: 1px solid #ddd;
    border-radius: 5px;
    z-index: 9999;
    background: url('data:image/svg+xml;base64,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') #fff no-repeat center center;
    box-shadow: 0px 3px 30px 0px rgba(7, 213, 105, 0.2);

  }
  .robotPic:hover .robot{
    display: block;
}

.robot{
    min-width:260px;
    float: right;
    text-align: left;
    padding:10px 30px;
    background:#fff;
    border-radius: 4px;
    display: none;
    position: absolute;
    right:50px;
    top:-193px;
    z-index: 100;
    box-shadow: 0 0 8px rgba(155, 155, 155, 0.5);
}
.robot .title{
    font-size:16px;
    color:#999999;
    line-height:26px;

}

.robot .qusType span{
    display:inline-block;
    font-size: 14px;
    color:#4d4d4d;
    line-height: 30px;
}

.robot .qusType span i{
    display:inline-block;
    width:4px;
    height:4px;
    border-radius: 2px;
    background:#999999;
    position: relative;
    right:4px;
    top:-2px;
}

.robot .linkToRobot{
    width:100%;
    border-top: 1px solid #ededed;
    margin-top:10px;
}

.robot .linkToRobot .s_btn{
    display: inline-block;
    margin: 10px 20px 0 10px;
    cursor: pointer;
}

.robot .linkToRobot .s_btn i{
    display:inline-block;
    width:20px;
    height:20px;
    background:url('data:image/svg+xml;base64,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') center no-repeat;
}

.robot .linkToRobot .s_btn span{
    color:#14cb6b;
    position: relative;
    top:-4px;
    margin-left: 5px;
}

.robot .linkToRobot .e_btn i{
    display:inline-block;
    width:20px;
    height:20px;
    background:url('data:image/svg+xml;base64,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') center no-repeat;
}

.robot .linkToRobot .e_btn span{
    color:#515151;
    position: relative;
    top:-4px;
    margin-left: 5px;
    cursor: pointer;
}
</style>
